import React from "react";
import "./CategoryCard.css";

const CategoryCard = ({ icon, title, description, onClick }) => {
  const handleClick = () => {
    onClick?.();
  };

  return (
    <div
      className="category-card"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleClick();
        }
      }}
    >
      <span className="category-icon">{icon}</span>
      <h3 className="category-title">{title}</h3>
      <p className="category-description">{description}</p>
    </div>
  );
};

export default CategoryCard;
